import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Button as Button$1 } from '@mui/material';
import { Icon } from '../Icon/Icon.js';
var _excluded = ["iconPosition", "label", "dataProp", "disabled"];
var Button = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var iconPosition = props.iconPosition,
      label = props.label,
      dataProp = props.dataProp,
      disabled = props.disabled,
      rest = _objectWithoutProperties(props, _excluded);

  var iconOrder = iconPosition === 'left' ? 1 : 2;
  var order = iconPosition === 'left' ? 2 : 1;
  var iconOnly = !rest.children;

  var iconSize = function iconSize() {
    if (rest.size === 'medium') {
      return 'small';
    }

    return rest.size;
  };

  var iconMargin = function iconMargin() {
    if (iconOnly || !rest.icon) {
      return '0';
    }

    if (iconOrder === 1) {
      return "0 0 0 8px";
    }

    return "0 8px 0 0";
  };

  var calculatedIconMargin = iconMargin();

  var variantType = function variantType() {
    var color = rest.color;

    if (color === 'primary') {
      return 'contained';
    }

    if (color === 'secondary') {
      return 'outlined';
    }

    return 'text';
  };

  return /*#__PURE__*/React.createElement(Button$1, _extends({
    disableRipple: true,
    variant: variantType()
  }, rest, {
    disabled: disabled,
    role: "button",
    "aria-label": label,
    ref: ref,
    "data-selector": dataProp,
    "aria-disabled": disabled
  }), rest.icon && /*#__PURE__*/React.createElement(Icon, {
    icon: rest.icon,
    fontSize: iconSize(),
    style: {
      order: iconOrder
    }
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      margin: calculatedIconMargin,
      order: order
    }
  }, /*#__PURE__*/React.createElement("span", null, rest.children)));
});
Button.displayName = 'Button';
export { Button };